module.exports = __webpack_public_path__ + "media/src/images/menu-a46f6f25c7556bc11663634d2dd2e00a.png";